import {Injectable} from "@angular/core";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {catchError, map, switchMap} from "rxjs/operators";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {BannerRemote} from "../domain/banner.remote";
import {Banner} from "../domain/dtos/banner";
import {BannerMapper} from "./mappers/banner.mapper";
import {Observable} from "rxjs";

@Injectable({
    providedIn: "root",
})
export class BannerWebService implements BannerRemote {

    private readonly BANNER_KEY = "APP";

    constructor(
        private baseHandler: EuropastryBaseHandler,
        private deliveryPointLocal: DeliveryPointLocal,
        private credentialsStorage: CredentialsStorage,
        private apiUrls: ApiUrls,
    ) { }

    getHomeBanner(): Observable<Banner | null> {
        const deliveryPointCode = this.deliveryPointLocal.getDeliveryPointCode();

        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .authorization(this.credentialsStorage.getCredentials())
            // /B/0/0 means that we want to get the bottom banner and the all pages of the pagination
            .url(this.apiUrls.BANNER + deliveryPointCode + "/" + this.BANNER_KEY + "/B/0/0")
            .build()

        return this.baseHandler.execute(parameters).pipe(
            map(BannerMapper.deserialize),
            catchError(BaseHandleErrorMapper.handleError)
        );
    }

    getTopBanner(): Observable<Banner | null> {
        return this.deliveryPointLocal.currentDeliveryPointCode$.pipe(switchMap(deliveryPointCode => {

            const parameters = new HandlerBuilder()
                .method(HttpMethod.get)
                .authorization(this.credentialsStorage.getCredentials())
                // /B/0/0 means that we want to get the bottom banner and the all pages of the pagination
                .url(this.apiUrls.BANNER + deliveryPointCode + "/" + this.BANNER_KEY + "/T/0/0")
                .build()

            return this.baseHandler.execute(parameters).pipe(
                map(BannerMapper.deserialize),
                catchError(BaseHandleErrorMapper.handleError)
            );
        }));
    }

}
